import { getArticle } from '../../api/ArticleApi'
import { ApiStatus } from '../../api/constants/ApiConstants'

export default {
  getArticleAction: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setArticleLoadingStatus', ApiStatus.progress)
      getArticle(payload)
        .then(({ data }) => {
          if (data) {
            commit('setArticle', data)
            resolve()
          } else {
            commit('setArticleFailure')
            resolve()
          }
        })
    })
  }
}
